/* Kopstorm - Anavrin returns and replacement parts, the flow.
   Paths:  parts   lookup > items > parts > review > done
           return  lookup > items > condition > resolution > review > done */
(function () {
  'use strict';

  var MAX_FILE = 10 * 1024 * 1024;
  var MAX_TOTAL = 20 * 1024 * 1024;
  var MAX_FILES = 5;

  var DEMO_ORDER = {
    name: '#12345',
    currency: 'USD',
    can_return: true,
    block_reason: null,
    items: [
      { id: 'demo-1', title: 'Golden Gai Book Nook Kit', variant: '', image: '', quantity: 1, price: '49.00', eligible: true },
      { id: 'demo-2', title: 'Kyoto Gion Book Nook Kit', variant: 'With dust cover', image: '', quantity: 2, price: '54.00', eligible: true },
      { id: 'demo-3', title: 'Acrylic Dust Cover', variant: 'Free gift', image: '', quantity: 1, price: '0.00', eligible: false, parts_eligible: false }
    ]
  };

  function lines(value) {
    return String(value || '').split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean);
  }

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  }

  function Portal(root) {
    this.root = root;
    this.cfg = JSON.parse(root.querySelector('[data-kop-rp-config]').textContent);
    this.t = this.cfg.text;
    this.endpoint = (root.dataset.endpoint || '').replace(/\/+$/, '');
    this.demo = root.dataset.demo === 'true';
    this.steps = {};
    this.state = { step: 'lookup', type: 'parts', order: null, email: '', orderNumber: '', selected: {}, files: { parts: [], condition: [] }, resolution: '' };

    var self = this;
    root.querySelectorAll('[data-kop-rp-step]').forEach(function (node) { self.steps[node.dataset.kopRpStep] = node; });
    this.bar = root.querySelector('[data-kop-rp-bar]');
    this.track = root.querySelector('[data-kop-rp-track]');
    this.fill = root.querySelector('[data-kop-rp-fill]');
    this.count = root.querySelector('[data-kop-rp-count]');
    this.bind();
    if (this.demo) root.querySelector('[data-kop-rp-preview]').hidden = false;
  }

  Portal.prototype.demoOrder = function () {
    var order = JSON.parse(JSON.stringify(DEMO_ORDER));
    var node = this.root.querySelector('[data-kop-rp-demo]');
    var products = [];
    try { products = node ? JSON.parse(node.textContent) : []; } catch (e) { products = []; }
    order.items.forEach(function (item, index) {
      var product = products[index];
      if (!product) return;
      if (product.title) item.title = product.title;
      if (product.image) item.image = product.image;
    });
    return order;
  };

  Portal.prototype.path = function () {
    return this.state.type === 'parts'
      ? ['lookup', 'items', 'parts', 'review']
      : ['lookup', 'items', 'condition', 'resolution', 'review'];
  };

  Portal.prototype.offerLive = function () {
    var mode = this.root.dataset.offer;
    if (mode === 'on') return true;
    if (mode === 'test') return document.documentElement.classList.contains('kop-rp-offer-live');
    return false;
  };

  Portal.prototype.bind = function () {
    var self = this;
    var root = this.root;

    this.steps.lookup.addEventListener('submit', function (event) {
      event.preventDefault();
      self.lookup();
    });

    root.querySelector('[data-kop-rp-back]').addEventListener('click', function () {
      var path = self.path();
      var index = path.indexOf(self.state.step);
      if (index > 0) self.go(path[index - 1]);
    });

    root.querySelectorAll('[data-kop-rp-next]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!self.validate(self.state.step)) return;
        var path = self.path();
        self.go(path[path.indexOf(self.state.step) + 1]);
      });
    });

    root.querySelectorAll('input[name="kop_rp_type"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        self.state.type = radio.value;
        self.state.selected = {};
        self.renderItems();
        self.progress();
      });
    });

    root.querySelectorAll('input[name="kop_rp_resolution"]').forEach(function (radio) {
      radio.addEventListener('change', function () { self.state.resolution = radio.value; });
    });

    root.querySelectorAll('[data-kop-rp-files]').forEach(function (input) {
      input.addEventListener('change', function () {
        self.addFiles(input.dataset.kopRpFiles, input.files);
        input.value = '';
      });
    });

    root.querySelector('[data-kop-rp-send]').addEventListener('click', function () { self.send(); });

    var copy = root.querySelector('[data-kop-rp-copy]');
    copy.addEventListener('click', function () {
      var code = root.querySelector('[data-kop-rp-code]').textContent;
      var label = copy.querySelector('.btn-text');
      var original = label.textContent;
      var done = function () {
        label.textContent = copy.dataset.copied;
        setTimeout(function () { label.textContent = original; }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done);
      else done();
    });
  };

  /* ---------- navigation ---------- */
  Portal.prototype.go = function (step) {
    var self = this;
    this.state.step = step;
    Object.keys(this.steps).forEach(function (key) { self.steps[key].hidden = key !== step; });
    if (step === 'resolution') this.syncResolution();
    if (step === 'review') this.renderReview();
    this.progress();
    var card = this.root.querySelector('[data-kop-rp-card]');
    if (card && card.scrollIntoView && card.getBoundingClientRect().top < 0) card.scrollIntoView({ block: 'start' });
    var heading = this.steps[step].querySelector('h1, h2');
    if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus({ preventScroll: true }); }
  };

  Portal.prototype.progress = function () {
    var path = this.path();
    var index = path.indexOf(this.state.step);
    var show = index > 0;
    this.bar.hidden = !show;
    this.track.hidden = !show;
    if (!show) return;
    this.count.textContent = this.t.step.replace('[current]', index + 1).replace('[total]', path.length);
    this.fill.style.width = Math.round(((index + 1) / path.length) * 100) + '%';
  };

  Portal.prototype.error = function (step, message) {
    var box = this.steps[step].querySelector('[data-kop-rp-error]');
    if (!box) return;
    box.textContent = message || '';
    box.hidden = !message;
  };

  /* ---------- step 1 ---------- */
  Portal.prototype.lookup = function () {
    var self = this;
    var form = this.steps.lookup;
    var order = form.elements.order.value.trim();
    var email = form.elements.email.value.trim();
    this.error('lookup', '');
    if (!order || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      this.error('lookup', this.t.errRequired);
      return;
    }
    this.state.orderNumber = order;
    this.state.email = email;
    var shipEmail = this.steps.parts && this.steps.parts.querySelector('[name="ship_email"]');
    if (shipEmail && !shipEmail.value) shipEmail.value = email;

    var button = form.querySelector('[data-kop-rp-submit]');
    button.classList.add('is-loading');

    var request = this.demo
      ? new Promise(function (resolve) { setTimeout(function () { resolve({ order: self.demoOrder() }); }, 400); })
      : fetch(this.endpoint + '/lookup', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ order: order, email: email })
        }).then(function (response) {
          return response.json().catch(function () { return {}; }).then(function (data) {
            if (!response.ok) { var err = new Error(data.error || 'error'); err.status = response.status; throw err; }
            return data;
          });
        });

    request.then(function (data) {
      button.classList.remove('is-loading');
      if (!data || !data.order || !data.order.items || !data.order.items.length) {
        self.error('lookup', self.t.errNotFound);
        return;
      }
      self.state.order = data.order;
      self.state.selected = {};
      self.prepareItems();
      self.go('items');
    }).catch(function (err) {
      button.classList.remove('is-loading');
      self.error('lookup', err && err.status === 404 ? self.t.errNotFound : self.t.errGeneric);
    });
  };

  /* ---------- step 2 ---------- */
  Portal.prototype.prepareItems = function () {
    var order = this.state.order;
    var note = this.root.querySelector('[data-kop-rp-blocknote]');
    var returnChoice = this.root.querySelector('[data-kop-rp-returnchoice]');
    var returnRadio = returnChoice.querySelector('input');
    var blocked = order.can_return === false;
    returnChoice.classList.toggle('is-disabled', blocked);
    returnRadio.disabled = blocked;
    note.hidden = !blocked;
    if (blocked) {
      note.textContent = order.block_reason === 'zero_total' ? this.t.zeroNote : this.t.windowNote;
      this.root.querySelector('input[name="kop_rp_type"][value="parts"]').checked = true;
    }
    var checked = this.root.querySelector('input[name="kop_rp_type"]:checked');
    this.state.type = checked ? checked.value : 'parts';
    this.renderItems();
  };

  Portal.prototype.money = function (amount) {
    var currency = this.state.order.currency || 'USD';
    try {
      return new Intl.NumberFormat(this.cfg.locale || 'en', { style: 'currency', currency: currency }).format(Number(amount));
    } catch (e) {
      return amount + ' ' + currency;
    }
  };

  /* A branded select. The wrapper behaves like a native select for the rest
     of the flow: it carries .value and fires a change event. */
  Portal.prototype.dropdown = function (placeholder, options, initial) {
    var root = this.root;
    var wrap = el('div', 'kop-rp__select');
    wrap.value = initial || '';
    var uid = 'kop-rp-dd-' + Math.random().toString(36).slice(2, 8);

    var button = el('button', 'kop-rp__select-btn');
    button.type = 'button';
    button.setAttribute('aria-haspopup', 'listbox');
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', uid);
    var label = el('span', 'kop-rp__select-label');
    button.appendChild(label);
    var chevron = root.querySelector('[data-kop-rp-chevron]');
    if (chevron) button.appendChild(chevron.content.cloneNode(true));

    var listbox = el('ul', 'kop-rp__select-list');
    listbox.id = uid;
    listbox.setAttribute('role', 'listbox');
    listbox.setAttribute('aria-label', placeholder);
    listbox.hidden = true;
    var check = root.querySelector('[data-kop-rp-check]');

    var render = function () {
      var current = options.filter(function (o) { return o.value === wrap.value; })[0];
      label.textContent = current ? current.label : placeholder;
      wrap.classList.toggle('is-placeholder', !current);
      Array.prototype.forEach.call(listbox.children, function (li) {
        li.setAttribute('aria-selected', li.dataset.value === wrap.value ? 'true' : 'false');
      });
    };

    options.forEach(function (option) {
      var li = el('li', 'kop-rp__select-option');
      li.setAttribute('role', 'option');
      li.tabIndex = -1;
      li.dataset.value = option.value;
      li.appendChild(el('span', '', option.label));
      if (check) li.appendChild(check.content.cloneNode(true));
      li.addEventListener('click', function () { choose(option.value); });
      li.addEventListener('keydown', function (event) {
        var items = Array.prototype.slice.call(listbox.children);
        var index = items.indexOf(li);
        if (event.key === 'ArrowDown') { event.preventDefault(); (items[index + 1] || li).focus(); }
        if (event.key === 'ArrowUp') { event.preventDefault(); (items[index - 1] || li).focus(); }
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); choose(option.value); }
        if (event.key === 'Escape' || event.key === 'Tab') { close(true); }
      });
      listbox.appendChild(li);
    });

    var outside = function (event) { if (!wrap.contains(event.target)) close(false); };
    var open = function () {
      root.querySelectorAll('.kop-rp__select.is-open').forEach(function (other) {
        if (other !== wrap && other.kopClose) other.kopClose(false);
      });
      listbox.hidden = false;
      wrap.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
      var active = listbox.querySelector('[aria-selected="true"]') || listbox.firstChild;
      if (active) active.focus({ preventScroll: true });
      document.addEventListener('click', outside, true);
    };
    var close = function (refocus) {
      listbox.hidden = true;
      wrap.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', outside, true);
      if (refocus) button.focus();
    };
    var choose = function (value) {
      var changed = wrap.value !== value;
      wrap.value = value;
      render();
      close(true);
      if (changed) wrap.dispatchEvent(new Event('change'));
    };
    wrap.kopClose = close;

    button.addEventListener('click', function () { if (listbox.hidden) open(); else close(false); });
    button.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') { event.preventDefault(); open(); }
    });

    wrap.appendChild(button);
    wrap.appendChild(listbox);
    render();
    return wrap;
  };

  Portal.prototype.renderItems = function () {
    var self = this;
    var list = this.root.querySelector('[data-kop-rp-items]');
    var isParts = this.state.type === 'parts';
    var reasons = lines(isParts ? this.cfg.reasonsParts : this.cfg.reasonsReturn);
    this.root.querySelector('[data-kop-rp-itemslabel]').textContent = isParts ? this.t.itemsParts : this.t.itemsReturn;
    this.error('items', '');
    list.textContent = '';

    this.state.order.items.forEach(function (item, index) {
      /* Free lines (gifts) can neither be returned nor chosen for a part. */
      var eligible = isParts ? item.parts_eligible !== false : item.eligible !== false;
      /* Free gift lines are left out of a parts request entirely. */
      if (isParts && !eligible) return;
      var row = el('div', 'kop-rp__item' + (eligible ? '' : ' is-ineligible'));
      var head = el('label', 'kop-rp__item-head');
      var box = document.createElement('input');
      box.type = 'checkbox';
      box.disabled = !eligible;
      box.id = 'KopRpItem-' + index;
      head.htmlFor = box.id;
      head.appendChild(box);

      var media = el('span', 'kop-rp__item-media');
      if (item.image) {
        var img = document.createElement('img');
        img.src = item.image.indexOf('width=') > -1 ? item.image : item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160';
        img.alt = '';
        img.loading = 'lazy';
        img.width = 56;
        img.height = 56;
        media.appendChild(img);
      } else {
        var noImage = self.root.querySelector('[data-kop-rp-noimage]');
        media.classList.add('is-empty');
        if (noImage) media.appendChild(noImage.content.cloneNode(true));
      }
      head.appendChild(media);

      var info = el('span', 'kop-rp__item-info');
      info.appendChild(el('span', 'heading text-sm', item.title));
      if (item.variant) info.appendChild(el('span', 'text-xs kop-rp__muted', item.variant));
      if (!eligible) info.appendChild(el('span', 'text-xs', self.t.ineligible));
      head.appendChild(info);
      if (!isParts) head.appendChild(el('span', 'kop-rp__item-price text-sm', self.money(item.price)));
      row.appendChild(head);

      var more = el('div', 'kop-rp__item-more');
      more.hidden = true;
      var line = el('div', 'kop-rp__item-row');

      var reasonField = el('div', 'field');
      var select = self.dropdown(self.t.reason, reasons.map(function (r) { return { value: r, label: r }; }), '');
      reasonField.appendChild(select);
      line.appendChild(reasonField);

      var qtySelect = null;
      if (!isParts && item.quantity > 1) {
        var qtyField = el('div', 'field field--qty');
        var qtyOptions = [];
        for (var q = 1; q <= item.quantity; q++) qtyOptions.push({ value: String(q), label: String(q) });
        qtySelect = self.dropdown(self.t.qty, qtyOptions, '1');
        qtyField.appendChild(qtySelect);
        line.appendChild(qtyField);
      }
      more.appendChild(line);

      var other = el('textarea', 'textarea');
      other.rows = 3;
      other.placeholder = self.t.other;
      other.setAttribute('aria-label', self.t.other);
      other.hidden = true;
      more.appendChild(other);
      row.appendChild(more);

      var sync = function () {
        if (!box.checked) { delete self.state.selected[item.id]; return; }
        self.state.selected[item.id] = {
          id: item.id,
          title: item.title,
          variant: item.variant || '',
          quantity: qtySelect ? Number(qtySelect.value) : 1,
          reason: select.value,
          detail: other.hidden ? '' : other.value.trim()
        };
      };

      box.addEventListener('change', function () {
        row.classList.toggle('is-selected', box.checked);
        more.hidden = !box.checked;
        sync();
      });
      select.addEventListener('change', function () {
        other.hidden = select.value.toLowerCase() !== 'other';
        sync();
      });
      other.addEventListener('input', sync);
      if (qtySelect) qtySelect.addEventListener('change', sync);

      list.appendChild(row);
    });
  };

  /* ---------- shipping details ---------- */
  Portal.prototype.shipping = function () {
    var step = this.steps.parts;
    var value = function (name) {
      var field = step.querySelector('[name="' + name + '"]');
      return field ? field.value.trim() : '';
    };
    return {
      name: value('ship_name'),
      address: value('ship_address'),
      city: value('ship_city'),
      state: value('ship_state'),
      zip: value('ship_zip'),
      country: value('ship_country'),
      email: value('ship_email'),
      phone: value('ship_phone')
    };
  };

  /* ---------- validation ---------- */
  Portal.prototype.validate = function (step) {
    var self = this;
    var state = this.state;
    var message = '';

    if (step === 'items') {
      var picked = Object.keys(state.selected).map(function (key) { return state.selected[key]; });
      if (!picked.length) message = this.t.errRequired;
      picked.forEach(function (item) {
        if (!item.reason) message = self.t.errRequired;
        if (item.reason.toLowerCase() === 'other' && item.detail.length < self.cfg.otherMin) message = self.t.errRequired;
      });
    }

    if (step === 'parts') {
      var part = this.steps.parts.querySelector('[name="part"]').value.trim();
      var input = this.steps.parts.querySelector('[data-kop-rp-files]');
      if (part.length < 3) message = this.t.errRequired;
      else if (input.dataset.required === 'true' && !state.files.parts.length) message = this.t.errPhotoRequired;
      else {
        var ship = this.shipping();
        var missing = Object.keys(ship).some(function (key) { return !ship[key]; });
        var emailField = this.steps.parts.querySelector('[name="ship_email"]');
        if (missing) message = this.t.errRequired;
        else if (emailField && !emailField.checkValidity()) message = this.t.errRequired;
      }
    }

    if (step === 'condition') {
      var needsPhoto = lines(this.cfg.photoReasons).map(function (r) { return r.toLowerCase(); });
      var photoRequired = Object.keys(state.selected).some(function (key) {
        return needsPhoto.indexOf(state.selected[key].reason.toLowerCase()) > -1;
      });
      if (!this.steps.condition.querySelector('[name="unopened"]').checked) message = this.t.errRequired;
      else if (photoRequired && !state.files.condition.length) message = this.t.errPhotoRequired;
    }

    if (step === 'resolution') {
      if (!state.resolution) message = this.t.errRequired;
    }

    this.error(step, message);
    return !message;
  };

  /* ---------- photos ---------- */
  Portal.prototype.addFiles = function (group, fileList) {
    var self = this;
    var files = this.state.files[group];
    var step = group === 'parts' ? 'parts' : 'condition';
    this.error(step, '');
    Array.prototype.forEach.call(fileList, function (file) {
      var total = files.reduce(function (sum, f) { return sum + f.size; }, 0);
      if (files.length >= MAX_FILES || file.size > MAX_FILE || total + file.size > MAX_TOTAL) {
        self.error(step, self.t.errPhoto);
        return;
      }
      files.push(file);
    });
    this.renderFiles(group);
  };

  Portal.prototype.renderFiles = function (group) {
    var self = this;
    var list = this.root.querySelector('[data-kop-rp-filelist="' + group + '"]');
    var closeIcon = this.root.querySelector('[data-kop-rp-closeicon]');
    list.textContent = '';
    this.state.files[group].forEach(function (file, index) {
      var li = el('li', 'kop-rp__file');
      if (/^image\/(jpeg|png|webp)$/.test(file.type)) {
        var img = document.createElement('img');
        img.src = URL.createObjectURL(file);
        img.alt = file.name;
        img.onload = function () { URL.revokeObjectURL(img.src); };
        li.appendChild(img);
      } else {
        li.appendChild(el('span', 'text-xs', file.name));
      }
      var remove = document.createElement('button');
      remove.type = 'button';
      remove.setAttribute('aria-label', 'Remove ' + file.name);
      if (closeIcon) remove.appendChild(closeIcon.content.cloneNode(true));
      remove.addEventListener('click', function () {
        self.state.files[group].splice(index, 1);
        self.renderFiles(group);
      });
      li.appendChild(remove);
      list.appendChild(li);
    });
  };

  /* ---------- resolution ---------- */
  Portal.prototype.syncResolution = function () {
    var live = this.offerLive();
    var radios = this.root.querySelectorAll('input[name="kop_rp_resolution"]');
    var current = this.root.querySelector('input[name="kop_rp_resolution"]:checked');
    if (current && current.value === 'keep' && !live) { current.checked = false; current = null; }
    if (!current) {
      /* Preselect the first visible option. A checked attribute set in markup
         fires no change event, so the state is written here. */
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].value === 'keep' && !live) continue;
        radios[i].checked = true;
        current = radios[i];
        break;
      }
    }
    this.state.resolution = current ? current.value : '';
    this.state.offerShown = live;
  };

  /* ---------- review ---------- */
  Portal.prototype.resolutionLabel = function () {
    return { keep: this.t.resKeep, credit: this.t.resCredit, refund: this.t.resRefund }[this.state.resolution] || '';
  };

  Portal.prototype.renderReview = function () {
    var self = this;
    var state = this.state;
    var list = this.root.querySelector('[data-kop-rp-review]');
    var isParts = state.type === 'parts';
    list.textContent = '';

    var row = function (label, values) {
      var wrap = el('div');
      wrap.appendChild(el('dt', '', label));
      var dd = el('dd');
      values.forEach(function (value) { dd.appendChild(el('span', '', value)); });
      wrap.appendChild(dd);
      list.appendChild(wrap);
    };

    row(this.t.rowRequest, [(isParts ? this.t.typeParts : this.t.typeReturn), state.order.name]);
    row(this.t.rowItems, Object.keys(state.selected).map(function (key) {
      var item = state.selected[key];
      return (item.quantity > 1 ? item.quantity + ' x ' : '') + item.title + ', ' + item.reason + (item.detail ? ' (' + item.detail + ')' : '');
    }));
    if (!isParts) row(this.t.rowResolution, [this.resolutionLabel()]);
    var photos = state.files[isParts ? 'parts' : 'condition'];
    if (photos.length) row(this.t.rowPhotos, [String(photos.length)]);
    if (isParts) {
      var ship = this.shipping();
      row(this.t.rowShip, [ship.name, ship.address, [ship.zip, ship.city].join(' '), [ship.state, ship.country].join(', '), ship.email, ship.phone]);
    }
  };

  /* ---------- submit ---------- */
  Portal.prototype.send = function () {
    var self = this;
    var state = this.state;
    var isParts = state.type === 'parts';
    var button = this.root.querySelector('[data-kop-rp-send]');
    var payload = {
      order: state.orderNumber,
      email: state.email,
      type: state.type,
      items: Object.keys(state.selected).map(function (key) { return state.selected[key]; }),
      part: isParts ? this.steps.parts.querySelector('[name="part"]').value.trim() : '',
      shipping: isParts ? this.shipping() : null,
      unopened: !isParts,
      note: isParts ? '' : this.steps.condition.querySelector('[name="note"]').value.trim(),
      resolution: isParts ? 'part' : state.resolution,
      offer_shown: isParts ? null : !!state.offerShown,
      page: location.href
    };

    this.error('review', '');
    button.classList.add('is-loading');

    var request;
    if (this.demo) {
      request = new Promise(function (resolve) {
        setTimeout(function () { resolve({ ok: true, code: null }); }, 500);
      });
    } else {
      var body = new FormData();
      body.append('payload', JSON.stringify(payload));
      state.files[isParts ? 'parts' : 'condition'].forEach(function (file) { body.append('photos', file, file.name); });
      request = fetch(this.endpoint + '/submit', { method: 'POST', body: body }).then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          if (!response.ok || !data.ok) throw new Error(data.error || 'error');
          return data;
        });
      });
    }

    request.then(function (data) {
      button.classList.remove('is-loading');
      self.finish(payload.resolution, data.code);
    }).catch(function () {
      button.classList.remove('is-loading');
      self.error('review', self.t.errGeneric);
    });
  };

  Portal.prototype.finish = function (resolution, code) {
    var key = resolution === 'part' ? 'parts' : resolution === 'keep' ? 'keep' : 'return';
    this.root.querySelectorAll('[data-kop-rp-done]').forEach(function (node) { node.hidden = node.dataset.kopRpDone !== key; });
    if (key === 'keep') {
      this.root.querySelector('[data-kop-rp-keepcopy="code"]').hidden = !code;
      this.root.querySelector('[data-kop-rp-keepcopy="pending"]').hidden = !!code;
      this.root.querySelector('[data-kop-rp-codebox]').hidden = !code;
      this.root.querySelector('[data-kop-rp-code]').textContent = code || '';
    }
    try {
      window.dispatchEvent(new CustomEvent('kop:returns:submitted', { detail: { type: this.state.type, resolution: resolution, offerShown: !!this.state.offerShown } }));
      if (window.dataLayer) window.dataLayer.push({ event: 'kop_returns_submitted', kop_returns_type: this.state.type, kop_returns_resolution: resolution, kop_returns_offer_shown: !!this.state.offerShown });
    } catch (e) {}
    this.go('done');
    this.bar.hidden = true;
    this.track.hidden = true;
  };

  function init() {
    document.querySelectorAll('[data-kop-rp]').forEach(function (root) {
      if (root.kopRp) return;
      root.kopRp = new Portal(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
